import React from "react";

export default function Footer() {
  return (
    <footer className="bg-dark text-light pt-5 pb-3">
      <div className="container">
        <div className="row">
          {/* Company */}
          <div className="col-6 col-md-3 mb-4">
            <h6 className="fw-bold border-bottom pb-2">Instituts de recherche</h6>
            <ul className="list-unstyled">
              <li><a href="#" className="text-decoration-none text-light">ISRA</a></li>
              <li><a href="#" className="text-decoration-none text-light">SAED</a></li>
              <li><a href="#" className="text-decoration-none text-light">USSEIN</a></li>
              <li><a href="#" className="text-decoration-none text-light">UGB</a></li>
              <li><a href="#" className="text-decoration-none text-light">ENSA</a></li>
            </ul>
          </div>

          {/* Products */}
          <div className="col-6 col-md-3 mb-4">
            <h6 className="fw-bold border-bottom pb-2">Produits</h6>
            <ul className="list-unstyled">
              <li><a href="/#apps" className="text-decoration-none text-light">Platforme Agrospace</a></li>
              <li><a href="/#apps" className="text-decoration-none text-light">Jaari chatbot </a></li>
              <li><a href="/#apps" className="text-decoration-none text-light">Monitoring </a></li>
              <li><a href="/produits" className="text-decoration-none text-light">Services profesionnels</a></li>
              <li><a href="/tarifs" className="text-decoration-none text-light">Tarifs freemium</a></li>
            </ul>
          </div>

          {/* Customers */}
          <div className="col-6 col-md-3 mb-4">
            <h6 className="fw-bold border-bottom pb-2">Customers</h6>
            <ul className="list-unstyled">
              <li><a href="/support" className="text-decoration-none text-light">Support</a></li>
              <li><a href="/support" className="text-decoration-none text-light">FAQ</a></li>
            </ul>
          </div>

          {/* Popular */}
          <div className="col-6 col-md-3 mb-4">
            <h6 className="fw-bold border-bottom pb-2">Popular</h6>
            <ul className="list-unstyled">
              <li><a href="/#video" className="text-decoration-none text-light">Video présentation</a></li>
              <li><a href="/produits" className="text-decoration-none text-light">Offres</a></li>
              <li><a href="/partenariats" className="text-decoration-none text-light">Partenaires</a></li>
            </ul>

            {/* Buttons */}
            <div className="d-grid gap-2 mt-4">
              <a href="/inscription" className="btn btn-success"> Créer un compte </a>
              <a href="/contact" className="btn btn-outline-light">Nos contacts </a>
            </div>
          </div>
        </div>

        {/* Logo */}
        <div className="text-center my-3">
          <h4 className="fw-bold text-success">AGROSPACE</h4>
        </div>

        {/* Bottom Section */}
        <div className="d-flex flex-column flex-md-row justify-content-between align-items-center pt-3 border-top">
          <p className="mb-2 mb-md-0">
            © 2025 Agrospace pack. Tout droit réservé.
          </p>

          <div className="d-flex flex-wrap gap-3">
            <p className="mb-2 mb-md-0">
               powered by Xelkoom-AI
            </p>
          </div>
        </div>

        {/* Social Icons */}
        <div className="d-flex justify-content-center gap-3 mt-3">
          <i className="bi bi-facebook fs-5"></i>
          <i className="bi bi-twitter-x fs-5"></i>
          <i className="bi bi-linkedin fs-5"></i>
          <i className="bi bi-github fs-5"></i>
          <i className="bi bi-instagram fs-5"></i>
          <i className="bi bi-youtube fs-5"></i>
        </div>
      </div>
    </footer>
  );
}
